'use client'

import dynamic from 'next/dynamic'
import { ClientAuthLoadingFallback } from '@/components/client/auth/ClientAuthLoadingFallback'
import { LoadingSpinner } from '@/components/ui/LoadingSpinner'

function PatientLoginLoading() {
  return (
    <div
      className="w-full flex flex-col items-center justify-center min-h-64 py-8"
      data-testid="login-page-client-loading"
    >
      <LoadingSpinner message="Loading…" variant="centered" size="lg" />
    </div>
  )
}

const LoginClientForClient = dynamic(() => import('./page.client'), {
  ssr: false,
  loading: () => <ClientAuthLoadingFallback />,
})

const LoginClientForPatient = dynamic(() => import('./page.client'), {
  ssr: false,
  loading: () => <PatientLoginLoading />,
})

export type LoginPageClientDynamicProps = { isClientPortal?: boolean }

export function LoginPageClientDynamic({ isClientPortal }: Readonly<LoginPageClientDynamicProps>) {
  const LoginClient = isClientPortal ? LoginClientForClient : LoginClientForPatient

  return <LoginClient isClientPortal={isClientPortal} />
}
